import { render, staticRenderFns } from "./BuilderRouter.vue?vue&type=template&id=49ea16fd&scoped=true"
import script from "./BuilderRouter.vue?vue&type=script&lang=js"
export * from "./BuilderRouter.vue?vue&type=script&lang=js"
import style0 from "./BuilderRouter.vue?vue&type=style&index=0&id=49ea16fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea16fd",
  null
  
)

export default component.exports